import { render, staticRenderFns } from "./SPFC-12-Away.vue?vue&type=template&id=7062c47c&"
import script from "./SPFC-12-Away.vue?vue&type=script&lang=js&"
export * from "./SPFC-12-Away.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports